function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import { Component } from "react";
import ReactDOM from "react-dom";
const canOpenPortal = typeof document !== "undefined";
export default class Portal extends Component {
  constructor(props) {
    super(props);
    if (!canOpenPortal) return;
    this._reactRootNode = document.createElement("div");

    this._reactRootNode.classList.add("AxiomSubtree");
  }

  componentDidMount() {
    if (!canOpenPortal) return;
    this.getParentNode().appendChild(this._reactRootNode);
  }

  componentWillUnmount() {
    if (!canOpenPortal) return;
    this.getParentNode().removeChild(this._reactRootNode);
  }

  getParentNode() {
    return this.props.parentNode || this.context.axiomPositionParentNode || document.body;
  }

  render() {
    if (!canOpenPortal) return null;
    return /*#__PURE__*/ReactDOM.createPortal(this.props.children, this._reactRootNode);
  }

}

_defineProperty(Portal, "contextTypes", {
  axiomPositionParentNode: PropTypes.object
});